import {Injectable, Pipe, PipeTransform} from '@angular/core'

@Pipe({name: 'cpfCnpjPipe'})
@Injectable({providedIn: 'root'})
export class CpfCnpjPipe implements PipeTransform {
  transform(value: string): string {
    if (!value) return value
    if (value.length === 11) {
      return value.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/g, '$1.$2.$3-$4')
    } else if (value.length === 14) {
      return value.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/g, '$1.$2.$3/$4-$5').replace(/\s+/g, '.')
    } else {
      return value
    }
  }
}
